import * as mfaActions from '../actions/mfa';

const initialState = {
    authMethods: {},
    authErrors: {},
    token_expired: false,
    authSuccess: false
}

export default (state = initialState, action) => {
    switch(action.type){
        case mfaActions.SET_AUTH_METHODS:
            return {
                ...state,
                authMethods: action.authMethods
            }
        case mfaActions.SET_AUTH_ERRORS:
            return {
                ...state,
                authErrors: action.errors
            }
        case mfaActions.RESET_AUTH_ERRORS:
            return {
                ...state,
                authErrors: {}
            }
        case mfaActions.SET_AUTH_SUCCESS_TRUE:
            return {
                ...state,
                authSuccess: true
            }
        case mfaActions.SET_AUTH_SUCCESS_FALSE:
            return {
                ...state,
                authSuccess: false
            }
        case mfaActions.SET_TOKEN_EXPIRED:
            return {
                ...state,
                token_expired: true
            }
        default:
            return state;
    }
}